module.exports = __webpack_public_path__ + "static/media/pins.a66c7ea0.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/Buildings/Manage/Map/Marker/img/pins.png
// module id = 1122
// module chunks = 0